import { render, staticRenderFns } from "./channelResource.vue?vue&type=template&id=0f443108&scoped=true&"
import script from "./channelResource.vue?vue&type=script&lang=js&"
export * from "./channelResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f443108",
  null
  
)

export default component.exports